import { useState } from "react";
import "./CustomTooltip.css";

const CustomTooltip = ({
  text,
  children,
  content,
  position = "top",
  backgroundColor = "#111",
  color = "#fff",
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className="tooltip-wrapper w-full h-full"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}

      {visible && (
        <div
          style={{ backgroundColor, color }}
          className={`tooltip-box ${position}`}
        >
          {content ?? text}
        </div>
      )}
    </div>
  );
};

export default CustomTooltip;
